import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  icon?: LucideIcon
  title: ReactNode
  description?: ReactNode
  /** What to do about it: one or two buttons. */
  actions?: ReactNode
  className?: string
}

/** An empty list says what would be here and how to get it there. */
export function EmptyState({ icon: Icon, title, description, actions, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center rounded-lg border border-dashed border-border px-6 py-10 text-center',
        className,
      )}
    >
      {Icon && (
        <span className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Icon size={18} aria-hidden />
        </span>
      )}
      <p className="text-section font-semibold">{title}</p>
      {description && <p className="mt-1.5 max-w-md text-body text-muted-foreground">{description}</p>}
      {actions && <div className="mt-4 flex flex-wrap justify-center gap-2">{actions}</div>}
    </div>
  )
}
